// import MDEditor from "@uiw/react-md-editor";
// import { useEffect, useMemo, useState } from "react";
// import { getAuth } from "firebase/auth";
// import { db } from "../../firebase";
// import { doc, getDoc } from "firebase/firestore";

// function extractDriveId(url = "") {
//   if (!url) return null;
//   return (
//     url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/)?.[1] ||
//     url.match(/[?&]id=([a-zA-Z0-9_-]+)/)?.[1] ||
//     url.match(/\/uc\?.*?[?&]id=([a-zA-Z0-9_-]+)/)?.[1]
//   );
// }
// function getDrivePreviewUrl(url = "") {
//   const id = extractDriveId(url);
//   return id ? `https://drive.google.com/uc?export=view&id=${id}` : "";
// }
// function priceStr(v) {
//   const n = Number(v);
//   if (!n) return "Free";
//   return `LKR ${n}`;
// }
// function DriveImagePreview({ url, size = "lg", rounded = true }) {
//   const [state, setState] = useState("loading");
//   const [src, setSrc] = useState(getDrivePreviewUrl(url));
//   useEffect(() => {
//     const next = getDrivePreviewUrl(url);
//     setSrc(next);
//     setState(next ? "loading" : "error");
//   }, [url]);
//   const handleError = () => {
//     const id = extractDriveId(url);
//     if (id && !src.includes("/thumbnail")) {
//       setSrc(`https://drive.google.com/thumbnail?id=${id}&sz=w1000`);
//       setState("loading");
//     } else {
//       setState("error");
//     }
//   };
//   const cls =
//     size === "sm"
//       ? `w-20 h-20 object-cover border ${rounded ? "rounded-lg" : ""}`
//       : size === "md"
//       ? `w-full max-w-md max-h-64 object-contain border ${
//           rounded ? "rounded-xl" : ""
//         }`
//       : `w-full aspect-video object-contain border ${
//           rounded ? "rounded-2xl" : ""
//         }`;
//   if (state === "error") return null;
//   return (
//     <img
//       src={src}
//       alt="Preview"
//       className={cls}
//       referrerPolicy="no-referrer"
//       loading="lazy"
//       onLoad={() => setState("ok")}
//       onError={handleError}
//     />
//   );
// }

// export default function StepReviewPreview({
//   loading,
//   values,
//   onBack,
//   onSubmit,
// }) {
//   const isProduct = (values?.type || "").toLowerCase() === "product";

//   // referral flag (for preview only)
//   const [referred, setReferred] = useState(false);
//   useEffect(() => {
//     const auth = getAuth();
//     const u = auth.currentUser;
//     if (!u) return;
//     (async () => {
//       try {
//         const snap = await getDoc(doc(db, "users", u.uid));
//         const d = snap.exists() ? snap.data() : null;
//         const isRef =
//           d?.referralKind === "instructor" &&
//           (!!d?.referredByUid || !!d?.referredByReferralCode);
//         setReferred(!!isRef);
//       } catch {
//         setReferred(false);
//       }
//     })();
//   }, []);

//   const productImagesRaw = Array.isArray(values.productImages)
//     ? values.productImages
//     : [];
//   const productImages = productImagesRaw.map((i) =>
//     typeof i === "string" ? { url: i, isMain: false } : i
//   );
//   const images = productImages.map((i) => i?.url).filter(Boolean);
//   const mainImg = productImages.find((i) => i?.isMain)?.url || images[0] || "";

//   const tagsArr =
//     typeof values.tags === "string"
//       ? values.tags
//           .split(",")
//           .map((t) => t.trim())
//           .filter(Boolean)
//       : Array.isArray(values.tags)
//       ? values.tags
//       : [];

//   const effectivePrice = useMemo(() => {
//     const base = Number(values?.price || 0);
//     if (!base) return base;
//     return referred ? Math.round(base * 1.15) : base;
//   }, [values?.price, referred]);

//   return (
//     <div className="flex flex-col gap-6">
//       <div className="bg-white rounded-2xl shadow-lg p-6">
//         <div className="flex items-start justify-between mb-4">
//           <h3 className="text-2xl font-extrabold">
//             {isProduct ? "Enter Product Details" : "Enter Course Details"}
//           </h3>
//           <div className="text-right">
//             <div className="flex items-center gap-2 justify-end">
//               {/* {referred && (
//                 <span className="bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full text-xs font-semibold">
//                   Referred (+15%)
//                 </span>
//               )} */}
//             </div>
//             <div className="text-sm text-gray-500 mt-1">Price</div>
//             <div className="text-lg font-bold">{priceStr(effectivePrice)}</div>
//             {referred && !!Number(values?.price) && (
//               <div className="text-[11px] text-gray-500">
//                 Base {priceStr(Number(values.price))} + 15%
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="grid lg:grid-cols-12 gap-6">
//           <div className="lg:col-span-5">
//             {isProduct ? (
//               <>
//                 {mainImg ? (
//                   <DriveImagePreview url={mainImg} size="lg" />
//                 ) : (
//                   <div className="w-full aspect-video rounded-2xl bg-gray-100 grid place-items-center text-gray-400">
//                     No image
//                   </div>
//                 )}
//                 {productImages.length > 1 && (
//                   <div className="mt-3 flex flex-wrap gap-2">
//                     {productImages.map((img, idx) => (
//                       <div key={idx} className="relative">
//                         <DriveImagePreview url={img.url} size="sm" />
//                         {img.isMain && (
//                           <span className="absolute -top-2 -right-2 bg-blue-600 text-white text-[10px] px-2 py-0.5 rounded-full shadow">
//                             Main
//                           </span>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </>
//             ) : (
//               <>
//                 {values.thumbnail ? (
//                   <DriveImagePreview url={values.thumbnail} size="lg" />
//                 ) : (
//                   <div className="w-full aspect-video rounded-2xl bg-gray-100 grid place-items-center text-gray-400">
//                     No thumbnail
//                   </div>
//                 )}
//               </>
//             )}
//           </div>

//           <div className="lg:col-span-7 flex flex-col gap-3">
//             <div className="text-2xl font-bold leading-tight">
//               {values.title}
//             </div>

//             <div className="flex flex-wrap items-center gap-2">
//               {isProduct ? (
//                 <>
//                   {values.category && (
//                     <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full text-sm">
//                       {values.category}
//                     </span>
//                   )}
//                   {values.subcategory && (
//                     <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full text-sm">
//                       {values.subcategory}
//                     </span>
//                   )}
//                 </>
//               ) : (
//                 values.category && (
//                   <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full text-sm">
//                     {values.category}
//                   </span>
//                 )
//               )}
//               {values.downloadable && (
//                 <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded-full text-xs">
//                   Downloadable
//                 </span>
//               )}
//               {values.pdfPreviewable && (
//                 <span className="bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full text-xs">
//                   Previewable
//                 </span>
//               )}
//             </div>

//             {!isProduct ? (
//               <p className="text-gray-600">{values.description}</p>
//             ) : values.productMainDesc ? (
//               <div className="prose max-w-none">
//                 <MDEditor.Markdown source={values.productMainDesc} />
//               </div>
//             ) : null}

//             {Array.isArray(tagsArr) && tagsArr.length > 0 && (
//               <div className="flex flex-wrap gap-1 pt-1">
//                 {tagsArr.map((tag, i) => (
//                   <span
//                     key={i}
//                     className="bg-gray-100 px-2 py-0.5 rounded-lg text-xs"
//                   >
//                     {tag}
//                   </span>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="sticky bottom-0 bg-white/90 backdrop-blur border-t py-3">
//         <div className="flex gap-2 justify-end">
//           <button
//             type="button"
//             className="px-4 py-2 rounded-xl bg-gray-100 text-gray-600"
//             onClick={onBack}
//             disabled={loading}
//           >
//             Back
//           </button>
//           <button
//             type="button"
//             className={`px-6 py-2 rounded-xl font-semibold transition ${
//               loading
//                 ? "bg-blue-300 text-white cursor-not-allowed"
//                 : "bg-blue-600 text-white hover:bg-blue-700"
//             }`}
//             onClick={onSubmit} // <- calls parent; parent saves
//             disabled={loading}
//           >
//             {loading ? "Uploading..." : "Submit"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import MDEditor from "@uiw/react-md-editor";
import { useEffect, useState } from "react";
import {
  readAffiliateCommissionByLevel,
  readAffiliateTotalCommission,
} from "../../utils/affiliateCommission";

/* ======================== helpers ======================== */
function extractDriveId(url = "") {
  if (!url) return null;
  return (
    url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/)?.[1] ||
    url.match(/[?&]id=([a-zA-Z0-9_-]+)/)?.[1] ||
    url.match(/\/uc\?.*?[?&]id=([a-zA-Z0-9_-]+)/)?.[1]
  );
}
function getDrivePreviewUrl(url = "") {
  const id = extractDriveId(url);
  return id ? `https://drive.google.com/uc?export=view&id=${id}` : "";
}
function currencyStr(n) {
  const v = Number(n || 0);
  if (!v) return "Free";
  return `LKR ${v.toLocaleString("en-LK", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}
function toArray(val) {
  if (Array.isArray(val)) return val;
  if (typeof val === "string")
    return val
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
  return [];
}

/* ---------- tiny preview component for Drive images ---------- */
function DriveImagePreview({ url, size = "lg", rounded = true }) {
  const [state, setState] = useState("loading");
  const [src, setSrc] = useState(getDrivePreviewUrl(url));
  useEffect(() => {
    const next = getDrivePreviewUrl(url);
    setSrc(next);
    setState(next ? "loading" : "error");
  }, [url]);
  const handleError = () => {
    const id = extractDriveId(url);
    if (id && !String(src || "").includes("/thumbnail")) {
      setSrc(`https://drive.google.com/thumbnail?id=${id}&sz=w1000`);
      setState("loading");
    } else {
      setState("error");
    }
  };
  const cls =
    size === "sm"
      ? `w-20 h-20 object-cover border ${rounded ? "rounded-lg" : ""}`
      : size === "md"
      ? `w-full max-w-md max-h-64 object-contain border ${
          rounded ? "rounded-xl" : ""
        }`
      : `w-full aspect-video object-contain border ${
          rounded ? "rounded-2xl" : ""
        }`;
  if (state === "error") return null;
  return (
    <img
      src={src}
      alt="Preview"
      className={cls}
      referrerPolicy="no-referrer"
      loading="lazy"
      onLoad={() => setState("ok")}
      onError={handleError}
    />
  );
}

function ImagePreview({ url, size = "lg", rounded = true }) {
  if (!url) return null;
  const isDrive = !!extractDriveId(url);
  if (isDrive) return <DriveImagePreview url={url} size={size} rounded={rounded} />;

  const cls =
    size === "sm"
      ? `w-20 h-20 object-cover border ${rounded ? "rounded-lg" : ""}`
      : size === "md"
      ? `w-full max-w-md max-h-64 object-contain border ${
          rounded ? "rounded-xl" : ""
        }`
      : `w-full aspect-video object-contain border ${
          rounded ? "rounded-2xl" : ""
        }`;

  return <img src={url} alt="Preview" className={cls} loading="lazy" />;
}

/* ======================== main ======================== */
export default function StepReviewPreview({
  loading,
  values,
  onBack,
  onSubmit,
}) {
  const t = (values?.type || "").toLowerCase();
  const isProduct = t === "product";
  const isCourse = t === "course";
  const isService = t === "service";

  /* ------------ product images (with main) ------------ */
  const productImagesRaw = Array.isArray(values.productImages)
    ? values.productImages
    : [];
  const productImages = productImagesRaw.map((i) =>
    typeof i === "string" ? { url: i, isMain: false } : i
  );
  const productImageUrls = productImages.map((i) => i?.url).filter(Boolean);
  const productMainImg =
    productImages.find((i) => i?.isMain)?.url || productImageUrls[0] || "";

  /* ------------ course images ------------ */
  const courseImages = Array.isArray(values.courseImages)
    ? values.courseImages
        .map((i) => (typeof i === "string" ? { url: i } : i))
        .filter((i) => i?.url)
    : [];

  /* ------------ service images ------------ */
  const serviceImages = Array.isArray(values.serviceImages)
    ? values.serviceImages
        .map((i) => (typeof i === "string" ? { url: i } : i))
        .filter((i) => i?.url)
    : [];

  /* ------------ tags ------------ */
  const tagsArr = toArray(values.tags);

  /* ------------ price logic ------------ */
  const pricingType =
    values.pricingType || (values.isHourly ? "hourly" : "fixed");
  const hourlyRate = Number(values.hourlyRate || 0);
  const minHours = Number(values.minHours || 0);
  const basePrice = Number(values.price || 0);

  const priceBadge =
    isService && pricingType === "hourly"
      ? `${currencyStr(hourlyRate)} / hour${
          minHours ? ` · min ${minHours}h` : ""
        }`
      : currencyStr(basePrice);

  /* ------------ course counts ------------ */
  const ytLinks = Array.isArray(values.youtubeLinks) ? values.youtubeLinks : [];
  const totalGlobalPdfs = Array.isArray(values.pdfLinks)
    ? values.pdfLinks.length
    : 0;
  const totalLessonPdfs = ytLinks.reduce(
    (sum, l) => sum + (Array.isArray(l.pdfs) ? l.pdfs.length : 0),
    0
  );
  const affiliateEnabled = !!values.affiliateEnabled;
  const affiliateCommissionAmount = readAffiliateTotalCommission(values);
  const affiliateBreakdown = readAffiliateCommissionByLevel(values);
  const wholesaleEnabled = !!values.wholesaleEnabled;
  const subCategory = values.subcategory || values.subCategory || "";
  const itemType = String(values.itemType || "").trim();
  const availableQuantity =
    values.stock != null && values.stock !== ""
      ? Number(values.stock)
      : values.inventory != null && values.inventory !== ""
        ? Number(values.inventory)
        : null;
  const wholesaleMinQty = Number(values.wholesaleMinQty || 0);
  const wholesalePrice =
    values.wholesalePrice !== "" && values.wholesalePrice != null
      ? Number(values.wholesalePrice || 0)
      : null;
  const wholesalePhone = String(values.wholesalePhone || "").trim();

  return (
    <div className="flex flex-col gap-6">
      <div className="bg-white rounded-2xl shadow-lg p-6">
        <div className="flex items-start justify-between mb-4">
          <h3 className="text-2xl font-extrabold">
            {isProduct
              ? "Review Product"
              : isCourse
              ? "Review Course"
              : "Review Service"}
          </h3>
          <div className="text-right">
            <div className="text-sm text-gray-500 mt-1">Pricing</div>
            <div className="text-lg font-bold">{priceBadge}</div>
            <div className="text-[11px] text-gray-500">
              Buyer pays this exact amount.
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-6 max-h-[450px] overflow-y-auto">
          <div className="lg:col-span-5">
            {isProduct ? (
              <>
                {productMainImg ? (
                  <ImagePreview url={productMainImg} size="lg" />
                ) : (
                  <div className="w-full aspect-video rounded-2xl bg-gray-100 grid place-items-center text-gray-400">
                    No image
                  </div>
                )}
                {productImages.length > 1 && (
                  <div className="mt-3 flex flex-wrap gap-2">
                    {productImages.map((img, idx) => (
                      <div key={idx} className="relative">
                        <ImagePreview url={img.url} size="sm" />
                        {img.isMain && (
                          <span className="absolute -top-2 -right-2 bg-blue-600 text-white text-[10px] px-2 py-0.5 rounded-full shadow">
                            Main
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : isCourse ? (
              <>
                {values.thumbnail ? (
                  <DriveImagePreview url={values.thumbnail} size="lg" />
                ) : (
                  <div className="w-full aspect-video rounded-2xl bg-gray-100 grid place-items-center text-gray-400">
                    No thumbnail
                  </div>
                )}
                {courseImages.length > 0 && (
                  <div className="mt-3 flex flex-wrap gap-2">
                    {courseImages.map((img, i) => (
                      <DriveImagePreview key={i} url={img.url} size="sm" />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <>
                {serviceImages[0]?.url ? (
                  <DriveImagePreview url={serviceImages[0].url} size="lg" />
                ) : (
                  <div className="w-full aspect-video rounded-2xl bg-gray-100 grid place-items-center text-gray-400">
                    No image
                  </div>
                )}
                {serviceImages.length > 1 && (
                  <div className="mt-3 flex flex-wrap gap-2">
                    {serviceImages.slice(1).map((img, i) => (
                      <DriveImagePreview key={i} url={img.url} size="sm" />
                    ))}
                  </div>
                )}
              </>
            )}
          </div>

          <div className="lg:col-span-7 flex flex-col gap-3">
            <div className="text-2xl font-bold leading-tight">
              {values.title}
            </div>

            <div className="flex flex-wrap items-center gap-2">
              {values.category && (
                <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full text-sm">
                  {values.category}
                </span>
              )}
              {(isProduct || isService) && subCategory && (
                <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full text-sm">
                  {subCategory}
                </span>
              )}
              {itemType && (
                <span className="bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full text-sm">
                  {itemType}
                </span>
              )}
              {isCourse && values.downloadable && (
                <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded-full text-xs">
                  Downloadable
                </span>
              )}
              {isCourse && values.pdfPreviewable && (
                <span className="bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full text-xs">
                  Previewable
                </span>
              )}
              {isService && values.allowDiscovery && (
                <span className="bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full text-xs">
                  Discovery Call
                </span>
              )}
              <span
                className={`px-2 py-0.5 rounded-full text-xs ${
                  affiliateEnabled
                    ? "bg-fuchsia-100 text-fuchsia-700"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {affiliateEnabled ? "Affiliate enabled" : "Affiliate off"}
              </span>
              {isProduct && wholesaleEnabled ? (
                <span className="bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full text-xs">
                  Wholesale enabled
                </span>
              ) : null}
            </div>

            {/* descriptions */}
            {isProduct && values.attributes?.length > 0 && <dl className="my-4 grid grid-cols-2 gap-3">{values.attributes.map((field, index) => <div key={field.id || index}><dt className="text-sm text-gray-500">{field.name}</dt><dd>{field.value}</dd></div>)}</dl>}
            {isProduct && values.productMainDesc ? (
              <div className="prose max-w-none">
                <MDEditor.Markdown source={values.productMainDesc} />
              </div>
            ) : isCourse ? (
              <p className="text-gray-600 whitespace-pre-wrap">
                {values.description}
              </p>
            ) : values.serviceDesc ? (
              <div className="prose max-w-none">
                <MDEditor.Markdown source={values.serviceDesc} />
              </div>
            ) : null}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="bg-gray-50 rounded-xl p-3">
                <div className="text-xs uppercase tracking-wide text-gray-500">
                  Affiliate status
                </div>
                <div className="mt-1 font-semibold text-gray-900">
                  {affiliateEnabled ? "Enabled" : "Disabled"}
                </div>
              </div>
              <div className="bg-gray-50 rounded-xl p-3">
                <div className="text-xs uppercase tracking-wide text-gray-500">
                  Affiliate share
                </div>
                <div className="mt-1 font-semibold text-gray-900">
                  {affiliateEnabled
                    ? currencyStr(affiliateCommissionAmount)
                    : "Not available"}
                </div>
                {affiliateEnabled ? (
                  <div className="mt-2 text-xs text-gray-500">
                    Direct {currencyStr(affiliateBreakdown[1])} • Upline 2{" "}
                    {currencyStr(affiliateBreakdown[2])} • Upline 3{" "}
                    {currencyStr(affiliateBreakdown[3])}
                  </div>
                ) : null}
                {affiliateEnabled ? (
                  <div className="mt-2 text-xs text-gray-500">
                    This share is deducted from your listed price, not added to
                    the buyer total.
                  </div>
                ) : null}
              </div>
              {isProduct ? (
                <div className="bg-gray-50 rounded-xl p-3">
                  <div className="text-xs uppercase tracking-wide text-gray-500">
                    Available Quantity
                  </div>
                  <div className="mt-1 font-semibold text-gray-900">
                    {availableQuantity != null && Number.isFinite(availableQuantity)
                      ? availableQuantity
                      : "Not set"}
                  </div>
                  <div className="mt-2 text-xs text-gray-500">
                    Buyers will see this as your live stock count.
                  </div>
                </div>
              ) : null}
            </div>

            {isProduct && wholesaleEnabled ? (
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
                <div className="bg-emerald-50 rounded-xl p-3">
                  <div className="text-xs uppercase tracking-wide text-emerald-700">
                    Retail Price
                  </div>
                  <div className="mt-1 font-semibold text-gray-900">
                    {currencyStr(basePrice)}
                  </div>
                </div>
                <div className="bg-emerald-50 rounded-xl p-3">
                  <div className="text-xs uppercase tracking-wide text-emerald-700">
                    Wholesale Offer
                  </div>
                  <div className="mt-1 font-semibold text-gray-900">
                    {wholesalePrice != null
                      ? `${currencyStr(wholesalePrice)} / unit`
                      : "Not set"}
                  </div>
                  <div className="mt-1 text-xs text-gray-500">
                    Minimum {wholesaleMinQty || 0} items
                  </div>
                </div>
                <div className="bg-emerald-50 rounded-xl p-3">
                  <div className="text-xs uppercase tracking-wide text-emerald-700">
                    Wholesale Mobile
                  </div>
                  <div className="mt-1 font-semibold text-gray-900">
                    {wholesalePhone || "Not set"}
                  </div>
                </div>
              </div>
            ) : null}

            {/* tags */}
            {tagsArr.length > 0 && (
              <div className="flex flex-wrap gap-1 pt-1">
                {tagsArr.map((tag, i) => (
                  <span
                    key={i}
                    className="bg-gray-100 px-2 py-0.5 rounded-lg text-xs"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}

            {/* product extras */}
            {isProduct &&
              Array.isArray(values.productSubDescs) &&
              values.productSubDescs.length > 0 && (
                <ul className="list-disc pl-5 space-y-1 text-gray-700">
                  {values.productSubDescs.map((d, i) => (
                    <li key={i}>{d}</li>
                  ))}
                </ul>
              )}

            {/* course stats */}
            {isCourse && (
              <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm">
                <div className="bg-gray-50 rounded-xl p-2">
                  Videos: <b>{ytLinks.length}</b>
                </div>
                <div className="bg-gray-50 rounded-xl p-2">
                  PDFs (global): <b>{totalGlobalPdfs}</b>
                </div>
                <div className="bg-gray-50 rounded-xl p-2">
                  PDFs (lessons): <b>{totalLessonPdfs}</b>
                </div>
              </div>
            )}

            {/* service details */}
            {isService && (
              <div className="mt-2 grid gap-3">
                {Array.isArray(values.serviceDeliverables) &&
                  values.serviceDeliverables.length > 0 && (
                    <div>
                      <div className="font-semibold mb-1">Deliverables</div>
                      <ul className="list-disc pl-5 space-y-1 text-gray-700">
                        {values.serviceDeliverables.map((d, i) => (
                          <li key={i}>{d}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                {Array.isArray(values.serviceFaqs) &&
                  values.serviceFaqs.length > 0 && (
                    <div>
                      <div className="font-semibold mb-1">FAQs</div>
                      <div className="space-y-3">
                        {values.serviceFaqs.map((f, i) => (
                          <div key={i} className="bg-gray-50 rounded-xl p-3">
                            <div className="font-medium">{f?.q}</div>
                            {f?.a ? (
                              <div className="prose max-w-none mt-1">
                                <MDEditor.Markdown source={f.a} />
                              </div>
                            ) : null}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-sm">
                  {values.deliveryDays !== undefined &&
                    values.deliveryDays !== "" && (
                      <div className="bg-gray-50 rounded-xl p-2">
                        Delivery: <b>{values.deliveryDays}d</b>
                      </div>
                    )}
                  {values.revisions !== undefined &&
                    values.revisions !== "" && (
                      <div className="bg-gray-50 rounded-xl p-2">
                        Revisions: <b>{values.revisions}</b>
                      </div>
                    )}
                  {pricingType === "hourly" && minHours ? (
                    <div className="bg-gray-50 rounded-xl p-2">
                      Min Hours: <b>{minHours}</b>
                    </div>
                  ) : null}
                  {values.depositPct ? (
                    <div className="bg-gray-50 rounded-xl p-2">
                      Deposit: <b>{values.depositPct}%</b>
                    </div>
                  ) : null}
                </div>
                {Array.isArray(values.contactMethods) &&
                  values.contactMethods.length > 0 && (
                    <div className="text-xs text-gray-600">
                      Preferred contact:{" "}
                      <span className="font-semibold">
                        {values.contactMethods.join(", ")}
                      </span>
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* actions */}
      <div className="sticky bottom-0 bg-white/90 backdrop-blur border-t py-3">
        <div className="flex gap-2 justify-end">
          <button
            type="button"
            className="px-4 py-2 rounded-xl bg-gray-100 text-gray-600"
            onClick={onBack}
            disabled={loading}
          >
            Back
          </button>
          <button
            type="button"
            className={`px-6 py-2 rounded-xl font-semibold transition ${
              loading
                ? "bg-blue-300 text-white cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
            onClick={onSubmit}
            disabled={loading}
          >
            {loading ? "Uploading..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}
